import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'deadTree',
      d: 'M-1.5,-7.5h0.5v0.5h-0.5zM0,-7.5h0.5v1h-0.5zM-1.5,-7h1v0.5h-1zM-1,-6.5h1.5v0.5h-1.5zM-3,-6h1v0.5h-1zM-0.5,-6h1v0.5h-1zM1.5,-6h1v0.5h-1zM-2.5,-5.5h0.5v0.5h-0.5zM0,-5.5h0.5v1h-0.5zM1.5,-5.5h0.5v0.5h-0.5zM-2.5,-5h1v0.5h-1zM1,-5h1v0.5h-1zM-2,-4.5h1v0.5h-1zM0,-4.5h1.5v0.5h-1.5zM0,-4h1v0.5h-1zM0,-3.5h0.5v2.5h-0.5zM-0.5,-1h1v0.5h-1zM-0.5,-0.5h1.5v0.5h-1.5zM-1,0h1v0.5h-1zM0.5,0h0.5v0.5h-0.5z',
    },
    {
      paint: 'fence',
      d: 'M-0.5,-7h0.5v0.5h-0.5zM-0.5,-5.5h0.5v1h-0.5zM-1.5,-5h0.5v0.5h-0.5zM-1,-4.5h1v1h-1zM-0.5,-3.5h0.5v2.5h-0.5zM-1,-0.5h0.5v0.5h-0.5z',
    },
  ],
  pixels: 56,
};
export const sprites: readonly PixelSprite[] = [variant0, variant0, variant0];
